import { render, staticRenderFns } from "./ProductStockSlip.vue?vue&type=template&id=ba7ca7e4&scoped=true"
import script from "./ProductStockSlip.vue?vue&type=script&lang=js"
export * from "./ProductStockSlip.vue?vue&type=script&lang=js"
import style0 from "./ProductStockSlip.vue?vue&type=style&index=0&id=ba7ca7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ca7e4",
  null
  
)

export default component.exports